import { f as d } from "./chunk-lit-element-CNHURX5C.js";
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const m = { INITIAL: 0, PENDING: 1, COMPLETE: 2, ERROR: 3 }, p = Symbol();
class v {
  get taskComplete() {
    return this.t || (this.i === 1 ? this.t = new Promise((t, i) => {
      this.o = t, this.h = i;
    }) : this.i === 3 ? this.t = Promise.reject(this.l) : this.t = Promise.resolve(this.u)), this.t;
  }
  constructor(t, i, h) {
    var r;
    this.p = 0, this.i = 0, (this._ = t).addController(this);
    const s = typeof i == "object" ? i : { task: i, args: h };
    this.v = s.task, this.j = s.args, this.m = s.argsEqual ?? g, this.k = s.onComplete, this.A = s.onError, this.autoRun = s.autoRun ?? !0, "initialValue" in s && (this.u = s.initialValue, this.i = 2, this.O = (r = this.T) == null ? void 0 : r.call(this));
  }
  hostUpdate() {
    this.autoRun === !0 && this.S();
  }
  hostUpdated() {
    this.autoRun === "afterUpdate" && this.S();
  }
  T() {
    if (this.j === void 0) return;
    const t = this.j();
    if (!Array.isArray(t)) throw Error("The args function must return an array");
    return t;
  }
  async S() {
    const t = this.T(), i = this.O;
    this.O = t, t === i || t === void 0 || i !== void 0 && this.m(i, t) || await this.run(t);
  }
  async run(t) {
    var a, o, n, u, l;
    let i, h;
    t ?? (t = this.T()), this.O = t, this.i === 1 ? (a = this.q) == null || a.abort() : (this.t = void 0, this.o = void 0, this.h = void 0), this.i = 1, this.autoRun === "afterUpdate" ? queueMicrotask(() => this._.requestUpdate()) : this._.requestUpdate();
    const s = ++this.p;
    this.q = new AbortController();
    let r = !1;
    try {
      i = await this.v(t, { signal: this.q.signal });
    } catch (c) {
      r = !0, h = c;
    }
    if (this.p === s) {
      if (i === p) this.i = 0;
      else {
        if (r === !1) {
          try {
            (o = this.k) == null || o.call(this, i);
          } catch {
          }
          this.i = 2, (n = this.o) == null || n.call(this, i);
        } else {
          try {
            (u = this.A) == null || u.call(this, h);
          } catch {
          }
          this.i = 3, (l = this.h) == null || l.call(this, h);
        }
        this.u = i, this.l = h;
      }
      this._.requestUpdate();
    }
  }
  abort(t) {
    var i;
    this.i === 1 && ((i = this.q) == null || i.abort(t));
  }
  get value() {
    return this.u;
  }
  get error() {
    return this.l;
  }
  get status() {
    return this.i;
  }
  render(t) {
    var i, h, s, r;
    switch (this.i) {
      case 0:
        return (i = t.initial) == null ? void 0 : i.call(t);
      case 1:
        return (h = t.pending) == null ? void 0 : h.call(t);
      case 2:
        return (s = t.complete) == null ? void 0 : s.call(t, this.value);
      case 3:
        return (r = t.error) == null ? void 0 : r.call(t, this.error);
      default:
        throw Error("Unexpected status: " + this.i);
    }
  }
}
const g = (e, t) => e === t || e.length === t.length && e.every((i, h) => !d(i, t[h]));
export {
  v as h,
  p as i,
  m as s
};
